import { DefaultOptionType } from 'antd/es/select';
import { ITable } from 'interfaces/Table/ColumnType';
import { ToastPosition } from 'react-toastify';

export const optionsToast = {
  position: 'top-right' as ToastPosition,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

export const DEFAULT_PAGE_SIZE = 10;

const getURLFromFileField = (field: string) => {
  return `https://docs.google.com/spreadsheets/d/${field}/export?format=xlsx`;
};

// 1REQRNcaVnODi3yUsR1hruA-epAgrxv8x

export const URL_IMPORT_TEMPLATE_FILE = {
  SALE_TEAM: getURLFromFileField('1kv0UdWRgtKUL6QgxI5qjS1_VpXPgSaz8'),
  HO_FOLLOW_PLAN: getURLFromFileField('1onMvSBD4KjBntQaNW4vDjfjYSQTqNxYC'),
  CN_PLAN: getURLFromFileField('18kzpob1S-oObfJX-SM0ZYOGq_0Rb2gZh'),
  // CN_PLAN: getURLFromFileField('1NSEDPE6c16GxwcNSZMHvzPLD-8Ovci8v'),
  HO_PLAN: getURLFromFileField('1nT36RH1dR1WygEjwOm2XEaHyI08yd6QJ'),
  // HO_PLAN: getURLFromFileField('1AS6QokvwZyZJVe611fNfhwfbvRv2SEf_'),
  HO_PLAN_DETAIL: getURLFromFileField('1EyNwerAXhsZYvFaw32c6IZy4DNE4abIL'),
  SALE_LINE: getURLFromFileField('1VJNbOdXkgDDdTaiJ2V2UJFK7Hnb_kZPJ'),
  CUSTOMER_TO_SALE_TEAM: getURLFromFileField(
    '1vCjCe6XEcthowEYC0p8YO-2_lBWClsAs',
  ),
  SALE_PLAN: getURLFromFileField('1KS7pQqNwmM72DZcCLdsXNPwVMZHUt4WI'),
  SALE_LINE_TEAM: getURLFromFileField('1Wp-dGqRI5lcqgqQCuOmEwi9F96Mr3otX'),
  CUSTOMER_TO_SALE_LINE: getURLFromFileField(
    '1Q14qIwZ_QZHDQTcdfwOR97UzMg6Jq0VO',
  ),
  SALES_TEAM_REVENUE: getURLFromFileField('1xN3LjO8byOFX5BXw05sH4qEfPx2CeHUx'),
  REWARD_CONDITION: getURLFromFileField(''),
  REWARD_FRAME: getURLFromFileField(''),
  GROUP_ROLE: getURLFromFileField(''),
  GROSS_PROFIT: getURLFromFileField(''),
  REWARD_CALCULATION: getURLFromFileField(''),
  REWARD_INFO: getURLFromFileField(''),
  HO_REVENUE: getURLFromFileField('14jJ9da0rhBTG-9mQav9rvRYzrNJ9nurc'),
  PLANT_REVENUE: getURLFromFileField('1rO1u52cipOV3qSluGooZlRSyHP-s4XZS'),
  ROUTE_COST: getURLFromFileField('1_vPYZPLjs6_4C6GxEN45JE5sGXLotJU7'),
};

export const months = [
  'janSaleamt',
  'febSaleamt',
  'marSaleamt',
  'aprSaleamt',
  'maySaleamt',
  'junSaleamt',
  'julSaleamt',
  'augSaleamt',
  'sepSaleamt',
  'octSaleamt',
  'novSaleamt',
  'decSaleamt',
];

export const POWERBI_ID = {
  OVERVIEW_REPORT: {
    reportId: '408e84d5-7ce8-44dd-8cd8-a4ae39b369c1',
    groupId: '175e6400-43d9-48bd-a582-fb4bca86eff2',
  },
  CUSTOMER_REPORT: {
    reportId: '877d990a-c231-4270-bc16-06267d63e523',
    groupId: '175e6400-43d9-48bd-a582-fb4bca86eff2',
  },
};

export const initDataTable: ITable<any> = {
  pageInfo: {
    currentPage: 1,
    hasNextPage: false,
    hasPreviousPage: false,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
  },
  items: [] as Array<any>,
};

export const comparisonSigns = {
  '1': '>',
  '2': '<',
  '3': '=',
  '4': '<=',
  '5': '>=',
};

export const comparisonSignOptions: DefaultOptionType[] = Object.entries(
  comparisonSigns,
).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const bonusConditions = {
  DT: 'Doanh thu',
  LG: 'Lãi gộp',
  DTTD: 'Doanh thu tối đa',
  LGTD: 'Lãi gộp tối đa',
};

export const typeRewardOptions: DefaultOptionType[] = Object.entries(
  bonusConditions,
).map(([key, value]) => ({
  label: value,
  value: key,
}));

export const yesNoOptions: DefaultOptionType[] = [
  {
    label: 'Y',
    value: 'Y',
  },
  {
    label: 'N',
    value: 'N',
  },
];

export const groupRewardOptions = [
  {
    label: 'Nhóm 1',
    value: 'gp001',
  },
  {
    label: 'Nhóm 2',
    value: 'gp002',
  },
];
